import { SignupForm } from "../../functionalities/signup/components/SignupForm";

export const Signup = () => {
  return <SignupForm />;
};
